import WeatherApp from "./WeatherApp";

export default WeatherApp;